export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "gradient": {
    "title": "Gradient Generator",
    "subtitle": "Create beautiful CSS gradients. Linear, radial, conic. ",
    "privacy": "100% client-side",
    "type": "Type",
    "linear": "Linear",
    "radial": "Radial",
    "conic": "Conic",
    "angle": "Angle",
    "stops": "Color Stops",
    "addStop": "Add",
    "random": "Random",
    "presets": "Presets"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All gradient generation happens locally in your browser. No design data is uploaded to any server."
    },
    "guide": {
      "title": "How to Use Gradient Generator",
      "description": "Create beautiful CSS gradients for websites, apps, and design projects.",
      "steps": [
        {
          "title": "Choose gradient type",
          "description": "Select linear, radial, or conic gradient types. Linear gradients work best for backgrounds, radial for focal points, and conic for color wheels."
        },
        {
          "title": "Add and arrange colors",
          "description": "Click to add color stops, then drag to position them along the gradient line. Use the color picker or enter HEX values for precision."
        },
        {
          "title": "Copy CSS code",
          "description": "Copy the generated CSS code directly into your stylesheet. The generator produces standards-compliant CSS for all modern browsers."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Linear, radial, and conic gradient types",
        "Interactive color stop positioning with drag-and-drop",
        "Real-time preview with customizable angle and size",
        "Copy-ready CSS output for modern browsers",
        "Preset gradients for quick inspiration",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my design data sent to a server?",
          "answer": "No. All gradient generation and preview rendering happens locally in your browser. No design data is transmitted or stored externally."
        },
        {
          "question": "Which browsers support these gradients?",
          "answer": "The generated CSS uses standard syntax supported by all modern browsers including Chrome, Firefox, Safari, Edge, and mobile browsers. IE11 is not supported."
        },
        {
          "question": "Can I export gradients as images?",
          "answer": "Currently the tool focuses on CSS output for web projects. For image export, use our Image Converter or Image Resizer tools after taking a screenshot."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Color Converter",
          "url": "/design/color-converter",
          "description": "Convert between HEX, RGB, HSL, and CMYK with contrast checking."
        },
        {
          "name": "CSS Minifier",
          "url": "/developer/css-minifier",
          "description": "Compress CSS to reduce file size for faster page loads."
        },
        {
          "name": "Image Resizer",
          "url": "/image/image-resizer",
          "description": "Resize images for social media, presentations, and web."
        }
      ]
    }
  }
};
